import Actions from './actions';

import Auth from './reducers/Auth';
import Client from './reducers/Client';
import PersonalInfo from './reducers/PersonalInfo';
import RecoveryPassword from './reducers/RecoveryPassword';
import TotalBalance from './reducers/TotalBalance';

const Reducers = {
  Auth,
  Client,
  PersonalInfo,
  RecoveryPassword,
  TotalBalance,
};

export default {
  Actions,
  Reducers,
};
